import React from 'react';
import { useCSS } from '../../../lib/hooks.js';
import { getQuestionScore, getMaxScore, answerScore } from '../../../lib/qz';

import ActionButton from '../../builder/ActionButton';
import Message from '../../builder/Message.js';

const Summary = (props) => {
	useCSS('comp/quiz.css');

	const quiz_resume = props.quiz_resume;
	const isRight = props.isRight;
	const questions = props.questions;
	const builder = props.builder;
	const user = props.user;
	const maxPoints = props.maxPoints;
	let data = [];

	if(user != undefined) {
		for(let qid in user) {
			let adjustment = 0;
			//Find the question in the quiz
			for(let i in questions) {
				if(questions[i].Question.id == qid) {
					let subtotal = 0;
					let o = $.extend({}, questions[i]);
					o.Question = $.extend({}, questions[i].Question);
					o.user = user[qid];

					o.subtotal = getQuestionScore(questions[i], user);
					o.maxPoints = getMaxScore(questions[i]);
					o.Answer = [];
					for(let j in questions[i].Answer) {
						for(let k in o.user) {
							if(k != questions[i].Answer[j].id) continue;

							questions[i].Answer[j].score = answerScore(questions[i].Answer[j], user, questions[i].Question);

							o.Answer.push(questions[i].Answer[j]);
							break;
						}
					}

					o.Question.pos -= adjustment;
					data.push(o);
					break;
				} else {
					if(!questions[i].Question.status) {
						adjustment++;
						continue;
					}
				}
			}
		}
	} else {
		data = questions;
	}

	//Sort by pos
	data.sort((a, b) => ((a.Question.pos < b.Question.pos) ? -1 : 1));

	const showTicks = (quiz_resume.detail == '2') ? true : false;

	let section_title = "";
	let section_title_class = ['question_label', 'gui_module', 'gui_main_text_color_on_bg'];
	switch(quiz_resume.detail) {
		case '2':
			section_title = (isRight) ? quiz_resume.messageok : ((quiz_resume.messageko == '') ? quiz_resume.messageok : quiz_resume.messageko);
			section_title_class.push((isRight) ? 'knk-on greenIcon' : 'knk-off redIcon');
			break;

		case '1':
			section_title = quiz_resume.messageok;
			break;

		case '0':
			section_title = quiz_resume.messageko;
			break;
	}

	const fakeRating = (stars, user) => {
		const children = [];
		user = parseInt(user);
		for(let i = 0; i < stars; i++) {
			children.push(<li class={(i < user) ? 'ep-star' : 'ep-star-empty'}></li>);
		}

		return children;
	};

	const continueButton = () => {
		if(props.onContinue) props.onContinue();
	};

	const restartButton = () => {
		if(props.onReset) props.onReset();
	};

	return (
		<div class="flex_container quiz_question single_columned">
			<div class="flex_col col_2">
				<article class="main_contents_flex">
					<div class="gui_question_content gui_module">
						<div class="question_content quiz_resume">
							{(section_title != "" && section_title != " ") && (
								<h1 class={section_title_class.join(" ")} dangerouslySetInnerHTML={{ __html: section_title }} />
							)}

							{(builder && quiz_resume.detail != '0') && (
								<ul class="questions_debug answers-container gui_module _1cols gui_main_text_color_on_bg">
									{questions.map((q, i) => {
										const question_title = (parseInt(i) + 1) + '. ' + q.Question.question;

										const question_classes = ['title', 'cutTextOnOverflow', 'hb_secondaryFont'];
										if(showTicks) {
											question_classes.push((maxPoints > 0 && subtotal == maxPoints) ? 'knk-on greenIcon' : 'knk-off redIcon');
										}

										return (
											<li key={i}>
												<div class="question_title_debug">
													<span class={question_classes.join(" ")} dangerouslySetInnerHTML={{ __html: question_title }} />
												</div>

												<ul class="answered_answers">
													<Message
														wrapper_type='li'
														title="User's answer for this question"
													/>
												</ul>
											</li>
										)
									})}
								</ul>
							)}

							{(!builder && quiz_resume.detail != '0') && (
								<ul class="questions_debug answers-container gui_module _1cols gui_main_text_color_on_bg">
									{data.map((q, i) => {
										const question_title = (parseInt(i) + 1) + '. ' + q.Question.question;

										const question_classes = ['title', 'cutTextOnOverflow', 'hb_secondaryFont'];
										if(showTicks) {
											question_classes.push((maxPoints > 0 && subtotal == maxPoints) ? 'knk-on greenIcon' : 'knk-off redIcon');
										}

										return (
											<li key={i}>
												<div class="question_title_debug">
													<span class={question_classes.join(" ")} dangerouslySetInnerHTML={{ __html: question_title }} />
												</div>

												<ul class="answered_answers">
													{q.Answer.map((a, i) => (
														<li key={i}>
															<span class={(showTicks ? 'ep-circle' + ((q.maxPoints > 0 && a.score != 0 && a.score == parseInt(a.correct)) ? ' knk-on greenIcon' : ' knk-off redIcon') : '')}>
																{q.Question.multiorder && (q.user[a.id] + ".")}

																{(a.config.type == 'closed_text') && (
																	a.answer_st
																)}

																{(a.config.type != 'closed_text') && (
																	<strong>{a.answer_st}: </strong>
																)}

																{(a.config.type == 'open_text' || a.config.type == 'list') && (
																	q.user[a.id]
																)}

																{(a.config.type == 'rating') && (
																	<div>
																		<ul class="rating_emulated">
																			{fakeRating(a.config.star_count, q.user[a.id])}
																		</ul> ({q.user[a.id]}/{a.config.star_count})
																	</div>
																)}
															</span>
														</li>
													))}
												</ul>
											</li>
										)
									})}
								</ul>
							)}

							<ul class="gui_module mod_align_right gui_main_text_color_on_bg">
								{(quiz_resume.buttons == 'both' || quiz_resume.buttons == 'start' || quiz_resume.buttons == undefined) && (
									<li class="flex_button">
										<ActionButton
											_fullclass=''
											onClick={restartButton}
										>Restart</ActionButton>
									</li>
								)}

								{(quiz_resume.buttons == 'both' || quiz_resume.buttons == 'continue') && (
									<li class="flex_button">
										<ActionButton
											_fullclass=''
											onClick={continueButton}
										>Continue</ActionButton>
									</li>
								)}
							</ul>
						</div>
					</div>
				</article>
			</div>
		</div>
	)
};

export default Summary;